module.exports = __webpack_public_path__ + "img/AL.903cad89.png";